import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { clientSettings } from 'go-modules/models/common/client.settings';

export interface DisableFeaturesResponse {
	disabled_features: {
		[key: string]: boolean
	};
}

@Injectable({
	providedIn: 'root'
})
export class DisabledFeaturesService {

	constructor (
		private http: HttpClient
	) {}

	public getDisabledFeatures (): Observable<DisableFeaturesResponse> {
		return this.http.get<DisableFeaturesResponse>(`${clientSettings.GoReactV2API}/disabled-features`);
	}
}
